import { connect } from 'react-redux'
import View from './MainMenuToggle'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const MainMenuToggle = connect(mapStateToProps)(View)

export default MainMenuToggle
